import React, { Component } from 'react'
import LazyLoad from 'react-lazyload'
import moment from 'moment'

import { Loader } from 'semantic-ui-react'
import { findAudio } from './utils'

class ArticleAudio extends Component {

  load (key, audio) {
    return (
      <LazyLoad key={key} overflow={true} scroll={false}
        placeholder={<Loader active size='small' />}>
        <audio controls preload="none" controlsList="nodownload"
               ref="mediaelt" src={audio.url}>
          Your browser does not support the audio element.
        </audio>
      </LazyLoad>
    )
  }

  render () {
    const { topicle, with_long_caption=false, with_urn_and_version_info=false } = this.props
    const media_groups = topicle.media_groups || topicle.associations

    let audio = findAudio(media_groups, {medium: 'audio'})
    const pubdate = topicle.version_created || topicle.versioncreated || topicle.updated
    if (!audio) {
      return null
    }

    return (
      <div>
        <header>
          <time className='publicationDate'>{ pubdate ? moment(pubdate).format('DD.MM.YYYY HH:mm') : '' }</time>
          { topicle.genre_names ? (<p className='genre'>{ topicle.genre_names[0] }</p>) : null }
          <h3>{ topicle.kicker || '' }</h3>
          <h1>{ topicle.title || topicle.headline }</h1>
        </header>

        <aside className='audios'>
          <figure class="audiowrapper" ref="mediawrapper">
            {this.load(topicle.urn, audio)}
            {with_long_caption ? (<figcaption className='long-caption'>{audio.description || ''}</figcaption>) : ''}
            {audio.transcript ?
              <div>
                <p>
                  <span>Transcript</span>
                </p>
              <figcaption className='urn-and-version-info'>{audio.transcript || ''}</figcaption>
             </div> : null
            }
            {with_urn_and_version_info ? (
            <figcaption className='urn-and-version-info'>
              <dl>
                <dt>urn</dt><dd>{ topicle.urn || topicle.uri }</dd>
                <dt>version</dt><dd>{ topicle.version }</dd>
                <dt>version_created</dt><dd>{ topicle.version_created || topicle.versioncreated || topicle.updated  }</dd>
              </dl>
            </figcaption>) : ''}
            {audio.url ?
              <section class="downloads">
              <p>Downloads</p>
              <ul>
                <li>
                  <a class="download" target="_blank" download="download.mp3"
                    href={audio.url}>
                    <span>download.{audio.mimetype}</span>
                  </a>
                </li>
              </ul>
              </section> : null
            }
          </figure>
        </aside>
      </div>
    )
  }
}

export default ArticleAudio



// WEBPACK FOOTER //
// ./src/probish/ArticleAudio.js